import { cn } from '../../utils/cn';

/**
 * Pílula ícone-sobre-label partilhada pela bottom bar mobile e pelo rail tablet
 * (`ds/nav/nav-item--stacked--active` / `--default` no .pen).
 *
 * .pen: width fill_container · rounded $radius-ds-md · vertical · gap $space-1
 * · padding [$space-2, $space-1] · alignItems center · ícone 22×22
 * · label $type-section (11px, lh 1.3, centrado) — activo 600 + $sage-tint/$sage-on-tint,
 * default normal + $fg-muted.
 */
export function StackedNavItem({ icon: Icon, label, active, nowrap = false }) {
  return (
    <span
      className={cn(
        'flex w-full flex-col items-center gap-space-1 rounded-ds-md px-space-1 py-space-2 transition-colors',
        active
          ? 'bg-sage-tint text-sage-on-tint'
          : 'text-muted-foreground',
      )}
    >
      {/* eslint-disable-next-line no-restricted-syntax -- ícone 22×22 do .pen, sem token de tamanho */}
      <Icon className="h-[22px] w-[22px] shrink-0" aria-hidden />
      <span
        className={cn(
          'w-full text-center text-type-chip',
          // No rail o .pen usa textGrowth auto + lineHeight 1.2: uma linha só,
          // que transborda a pílula (48px) mas cabe dentro do rail (72px).
          nowrap ? 'whitespace-nowrap leading-[1.2]' : 'leading-[1.3]',
          active ? 'font-semibold' : 'font-normal',
        )}
      >
        {label}
      </span>
    </span>
  );
}

export default StackedNavItem;
